export default {
  backendUrl: `${process.env.VUE_APP_BACKEND}/api`,
  frontendUrl: `${process.env.VUE_APP_FRONTEND}`,
  stripeKey1:process.env.VUE_APP_STRIPE_KEY_1,
  stripeKeyLucid:process.env.VUE_APP_STRIPE_KEY_LUCID
}
